import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AiAnalystScopeService } from '../services/ai-analyst-scope.service';

@Injectable({ providedIn: 'root' })
export class AiAnalystGuard implements CanActivate {
    constructor(
        private aiAnalystScopeService: AiAnalystScopeService,
        private authService: AuthService,
        private router: Router,
    ) {}

    canActivate(): boolean {
        if (this.aiAnalystScopeService.canAccessAiAnalyst) {
            return true;
        }
        this.router.navigate([this.authService.getLandingPageUrl()]);
        return false;
    }
}
